import _objectWithoutProperties from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getLengthFromAxis(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'x' : 'y';
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  var reference = _ref.reference,
    floating = _ref.floating;
  var commonX = reference.x + reference.width / 2 - floating.width / 2;
  var commonY = reference.y + reference.height / 2 - floating.height / 2;
  var mainAxis = getMainAxisFromPlacement(placement);
  var length = getLengthFromAxis(mainAxis);
  var commonAlign = reference[length] / 2 - floating[length] / 2;
  var side = getSide(placement);
  var isVertical = mainAxis === 'x';
  var coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
var computePosition = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reference, floating, config) {
    var _config$placement, placement, _config$strategy, strategy, _config$middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPla, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware$i, name, fn, _yield$fn, nextX, nextY, data, reset, _computeCoordsFromPla2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _config$placement = config.placement, placement = _config$placement === void 0 ? 'bottom' : _config$placement, _config$strategy = config.strategy, strategy = _config$strategy === void 0 ? 'absolute' : _config$strategy, _config$middleware = config.middleware, middleware = _config$middleware === void 0 ? [] : _config$middleware, platform = config.platform;
          validMiddleware = middleware.filter(Boolean);
          _context.next = 4;
          return platform.isRTL == null ? void 0 : platform.isRTL(floating);
        case 4:
          rtl = _context.sent;
          _context.next = 7;
          return platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
          });
        case 7:
          rects = _context.sent;
          _computeCoordsFromPla = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPla.x, y = _computeCoordsFromPla.y;
          statefulPlacement = placement;
          middlewareData = {};
          resetCount = 0;
          i = 0;
        case 13:
          if (!(i < validMiddleware.length)) {
            _context.next = 46;
            break;
          }
          _validMiddleware$i = validMiddleware[i], name = _validMiddleware$i.name, fn = _validMiddleware$i.fn;
          _context.next = 17;
          return fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
              reference: reference,
              floating: floating
            }
          });
        case 17:
          _yield$fn = _context.sent;
          nextX = _yield$fn.x;
          nextY = _yield$fn.y;
          data = _yield$fn.data;
          reset = _yield$fn.reset;
          x = nextX != null ? nextX : x;
          y = nextY != null ? nextY : y;
          middlewareData = _objectSpread({}, middlewareData, _defineProperty({}, name, _objectSpread({}, middlewareData[name], data)));
          if (!(reset && resetCount <= 50)) {
            _context.next = 43;
            break;
          }
          resetCount++;
          if (!(typeof reset === 'object')) {
            _context.next = 41;
            break;
          }
          if (reset.placement) {
            statefulPlacement = reset.placement;
          }
          if (!reset.rects) {
            _context.next = 38;
            break;
          }
          if (!(reset.rects === true)) {
            _context.next = 36;
            break;
          }
          _context.next = 33;
          return platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
          });
        case 33:
          _context.t0 = _context.sent;
          _context.next = 37;
          break;
        case 36:
          _context.t0 = reset.rects;
        case 37:
          rects = _context.t0;
        case 38:
          _computeCoordsFromPla2 = computeCoordsFromPlacement(rects, statefulPlacement, rtl);
          x = _computeCoordsFromPla2.x;
          y = _computeCoordsFromPla2.y;
        case 41:
          i = -1;
          return _context.abrupt("continue", 43);
        case 43:
          i++;
          _context.next = 13;
          break;
        case 46:
          return _context.abrupt("return", {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
          });
        case 47:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function computePosition(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
function expandPaddingObject(padding) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}
function getSideObjectFromPadding(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return _objectSpread({}, rect, {
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
function detectOverflow(_x4, _x5) {
  return _detectOverflow.apply(this, arguments);
}
function _detectOverflow() {
  _detectOverflow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(state, options) {
    var _await$platform$isEle, x, y, platform, rects, elements, strategy, _options8, _options8$boundary, boundary, _options8$rootBoundar, rootBoundary, _options8$elementCont, elementContext, _options8$altBoundary, altBoundary, _options8$padding, padding, paddingObject, altContext, element, clippingClientRect, rect, offsetParent, offsetScale, elementClientRect;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (options === void 0) {
            options = {};
          }
          x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
          _options8 = options, _options8$boundary = _options8.boundary, boundary = _options8$boundary === void 0 ? 'clippingAncestors' : _options8$boundary, _options8$rootBoundar = _options8.rootBoundary, rootBoundary = _options8$rootBoundar === void 0 ? 'viewport' : _options8$rootBoundar, _options8$elementCont = _options8.elementContext, elementContext = _options8$elementCont === void 0 ? 'floating' : _options8$elementCont, _options8$altBoundary = _options8.altBoundary, altBoundary = _options8$altBoundary === void 0 ? false : _options8$altBoundary, _options8$padding = _options8.padding, padding = _options8$padding === void 0 ? 0 : _options8$padding;
          paddingObject = getSideObjectFromPadding(padding);
          altContext = elementContext === 'floating' ? 'reference' : 'floating';
          element = elements[altBoundary ? altContext : elementContext];
          _context10.t0 = rectToClientRect;
          _context10.t1 = platform;
          _context10.next = 10;
          return platform.isElement == null ? void 0 : platform.isElement(element);
        case 10:
          _context10.t2 = _await$platform$isEle = _context10.sent;
          if (!(_context10.t2 != null)) {
            _context10.next = 15;
            break;
          }
          _context10.t3 = _await$platform$isEle;
          _context10.next = 16;
          break;
        case 15:
          _context10.t3 = true;
        case 16:
          if (!_context10.t3) {
            _context10.next = 20;
            break;
          }
          _context10.t4 = element;
          _context10.next = 26;
          break;
        case 20:
          _context10.t5 = element.contextElement;
          if (_context10.t5) {
            _context10.next = 25;
            break;
          }
          _context10.next = 24;
          return platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating);
        case 24:
          _context10.t5 = _context10.sent;
        case 25:
          _context10.t4 = _context10.t5;
        case 26:
          _context10.t6 = _context10.t4;
          _context10.t7 = boundary;
          _context10.t8 = rootBoundary;
          _context10.t9 = strategy;
          _context10.t10 = {
            element: _context10.t6,
            boundary: _context10.t7,
            rootBoundary: _context10.t8,
            strategy: _context10.t9
          };
          _context10.next = 33;
          return _context10.t1.getClippingRect.call(_context10.t1, _context10.t10);
        case 33:
          _context10.t11 = _context10.sent;
          clippingClientRect = (0, _context10.t0)(_context10.t11);
          rect = elementContext === 'floating' ? _objectSpread({}, rects.floating, {
            x: x,
            y: y
          }) : rects.reference;
          _context10.next = 38;
          return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating);
        case 38:
          offsetParent = _context10.sent;
          _context10.next = 41;
          return platform.isElement == null ? void 0 : platform.isElement(offsetParent);
        case 41:
          if (!_context10.sent) {
            _context10.next = 50;
            break;
          }
          _context10.next = 44;
          return platform.getScale == null ? void 0 : platform.getScale(offsetParent);
        case 44:
          _context10.t13 = _context10.sent;
          if (_context10.t13) {
            _context10.next = 47;
            break;
          }
          _context10.t13 = {
            x: 1,
            y: 1
          };
        case 47:
          _context10.t12 = _context10.t13;
          _context10.next = 51;
          break;
        case 50:
          _context10.t12 = {
            x: 1,
            y: 1
          };
        case 51:
          offsetScale = _context10.t12;
          _context10.t14 = rectToClientRect;
          if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) {
            _context10.next = 59;
            break;
          }
          _context10.next = 56;
          return platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
          });
        case 56:
          _context10.t15 = _context10.sent;
          _context10.next = 60;
          break;
        case 59:
          _context10.t15 = rect;
        case 60:
          _context10.t16 = _context10.t15;
          elementClientRect = (0, _context10.t14)(_context10.t16);
          return _context10.abrupt("return", {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
          });
        case 63:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _detectOverflow.apply(this, arguments);
}
var min = Math.min;
var max = Math.max;
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
var arrow = function arrow(options) {
  return {
    name: 'arrow',
    options: options,
    fn: function () {
      var _fn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(state) {
        var _data, _ref4;
        var _ref3, element, _ref3$padding, padding, x, y, placement, rects, platform, elements, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, centerToReference, min, max, center, offset, shouldAddOffset, alignmentOffset;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Since `element` is required, we don't Partial<> the type.
              _ref3 = options || {}, element = _ref3.element, _ref3$padding = _ref3.padding, padding = _ref3$padding === void 0 ? 0 : _ref3$padding;
              x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
              if (!(element == null)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", {});
            case 4:
              paddingObject = getSideObjectFromPadding(padding);
              coords = {
                x: x,
                y: y
              };
              axis = getMainAxisFromPlacement(placement);
              length = getLengthFromAxis(axis);
              _context2.next = 10;
              return platform.getDimensions(element);
            case 10:
              arrowDimensions = _context2.sent;
              isYAxis = axis === 'y';
              minProp = isYAxis ? 'top' : 'left';
              maxProp = isYAxis ? 'bottom' : 'right';
              clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
              endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
              startDiff = coords[axis] - rects.reference[axis];
              _context2.next = 19;
              return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element);
            case 19:
              arrowOffsetParent = _context2.sent;
              clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0; // DOM platform can return `window` as the `offsetParent`.
              _context2.t0 = !clientSize;
              if (_context2.t0) {
                _context2.next = 26;
                break;
              }
              _context2.next = 25;
              return platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent);
            case 25:
              _context2.t0 = !_context2.sent;
            case 26:
              if (!_context2.t0) {
                _context2.next = 28;
                break;
              }
              clientSize = elements.floating[clientProp] || rects.floating[length];
            case 28:
              centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
              // point is outside the floating element's bounds.
              min = paddingObject[minProp];
              max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
              center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
              offset = within(min, center, max); // If the reference is small enough that the arrow's padding causes it to
              // to point to nothing for an aligned placement, adjust the offset of the
              // floating element itself. This stops `shift()` from taking action, but can
              // be worked around by calling it again after the `arrow()` if desired.
              shouldAddOffset = getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
              alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
              return _context2.abrupt("return", (_ref4 = {}, _defineProperty(_ref4, axis, coords[axis] - alignmentOffset), _defineProperty(_ref4, "data", (_data = {}, _defineProperty(_data, axis, offset), _defineProperty(_data, "centerOffset", center - offset), _data)), _ref4));
            case 36:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function fn(_x6) {
        return _fn.apply(this, arguments);
      }
      return fn;
    }()
  };
};
var sides = ['top', 'right', 'bottom', 'left'];
var allPlacements = /*#__PURE__*/sides.reduce(function (acc, side) {
  return acc.concat(side, side + "-start", side + "-end");
}, []);
var oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (side) {
    return oppositeSideMap[side];
  });
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  var alignment = getAlignment(placement);
  var mainAxis = getMainAxisFromPlacement(placement);
  var length = getLengthFromAxis(mainAxis);
  var mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}
var oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, function (alignment) {
    return oppositeAlignmentMap[alignment];
  });
}
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  var allowedPlacementsSortedByAlignment = alignment ? [].concat(_toConsumableArray(allowedPlacements.filter(function (placement) {
    return getAlignment(placement) === alignment;
  })), _toConsumableArray(allowedPlacements.filter(function (placement) {
    return getAlignment(placement) !== alignment;
  }))) : allowedPlacements.filter(function (placement) {
    return getSide(placement) === placement;
  });
  return allowedPlacementsSortedByAlignment.filter(function (placement) {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
var autoPlacement = function autoPlacement(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options: options,
    fn: function () {
      var _fn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(state) {
        var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _options, _options$crossAxis, crossAxis, alignment, _options$allowedPlace, allowedPlacements, _options$autoAlignmen, autoAlignment, detectOverflowOptions, placements, overflow, currentIndex, currentPlacement, _getAlignmentSides, main, cross, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
              _options = options, _options$crossAxis = _options.crossAxis, crossAxis = _options$crossAxis === void 0 ? false : _options$crossAxis, alignment = _options.alignment, _options$allowedPlace = _options.allowedPlacements, allowedPlacements = _options$allowedPlace === void 0 ? allPlacements : _options$allowedPlace, _options$autoAlignmen = _options.autoAlignment, autoAlignment = _options$autoAlignmen === void 0 ? true : _options$autoAlignmen, detectOverflowOptions = _objectWithoutProperties(_options, ["crossAxis", "alignment", "allowedPlacements", "autoAlignment"]);
              placements = alignment !== undefined || allowedPlacements === allPlacements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
              _context3.next = 5;
              return detectOverflow(state, detectOverflowOptions);
            case 5:
              overflow = _context3.sent;
              currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
              currentPlacement = placements[currentIndex];
              if (!(currentPlacement == null)) {
                _context3.next = 10;
                break;
              }
              return _context3.abrupt("return", {});
            case 10:
              _context3.t0 = getAlignmentSides;
              _context3.t1 = currentPlacement;
              _context3.t2 = rects;
              _context3.next = 15;
              return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);
            case 15:
              _context3.t3 = _context3.sent;
              _getAlignmentSides = (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t3);
              main = _getAlignmentSides.main;
              cross = _getAlignmentSides.cross;
              if (!(placement !== currentPlacement)) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt("return", {
                reset: {
                  placement: placements[0]
                }
              });
            case 21:
              currentOverflows = [overflow[getSide(currentPlacement)], overflow[main], overflow[cross]];
              allOverflows = [].concat(_toConsumableArray(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), [{
                placement: currentPlacement,
                overflows: currentOverflows
              }]);
              nextPlacement = placements[currentIndex + 1]; // There are more placements to check.
              if (!nextPlacement) {
                _context3.next = 26;
                break;
              }
              return _context3.abrupt("return", {
                data: {
                  index: currentIndex + 1,
                  overflows: allOverflows
                },
                reset: {
                  placement: nextPlacement
                }
              });
            case 26:
              placementsSortedByMostSpace = allOverflows.map(function (d) {
                var alignment = getAlignment(d.placement);
                return [d.placement, alignment && crossAxis ?
                // Check along the mainAxis and main crossAxis side.
                d.overflows.slice(0, 2).reduce(function (acc, v) {
                  return acc + v;
                }, 0) :
                // Check only the mainAxis.
                d.overflows[0], d.overflows];
              }).sort(function (a, b) {
                return a[1] - b[1];
              });
              placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function (d) {
                return d[2].slice(0,
                // Aligned placements should not check their opposite crossAxis
                // side.
                getAlignment(d[0]) ? 2 : 3).every(function (v) {
                  return v <= 0;
                });
              });
              resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
              if (!(resetPlacement !== placement)) {
                _context3.next = 31;
                break;
              }
              return _context3.abrupt("return", {
                data: {
                  index: currentIndex + 1,
                  overflows: allOverflows
                },
                reset: {
                  placement: resetPlacement
                }
              });
            case 31:
              return _context3.abrupt("return", {});
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function fn(_x7) {
        return _fn2.apply(this, arguments);
      }
      return fn;
    }()
  };
};
function getExpandedPlacements(placement) {
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getSideList(side, isStart, rtl) {
  var lr = ['left', 'right'];
  var rl = ['right', 'left'];
  var tb = ['top', 'bottom'];
  var bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  var alignment = getAlignment(placement);
  var list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(function (side) {
      return side + "-" + alignment;
    });
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
var flip = function flip(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options: options,
    fn: function () {
      var _fn3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(state) {
        var _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _options2, _options2$mainAxis, checkMainAxis, _options2$crossAxis, checkCrossAxis, specifiedFallbackPlacements, _options2$fallbackStr, fallbackStrategy, _options2$fallbackAxi, fallbackAxisSideDirection, _options2$flipAlignme, flipAlignment, detectOverflowOptions, side, isBasePlacement, rtl, fallbackPlacements, placements, overflow, overflows, overflowsData, _getAlignmentSides2, main, cross, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$map$so, _placement;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
              _options2 = options, _options2$mainAxis = _options2.mainAxis, checkMainAxis = _options2$mainAxis === void 0 ? true : _options2$mainAxis, _options2$crossAxis = _options2.crossAxis, checkCrossAxis = _options2$crossAxis === void 0 ? true : _options2$crossAxis, specifiedFallbackPlacements = _options2.fallbackPlacements, _options2$fallbackStr = _options2.fallbackStrategy, fallbackStrategy = _options2$fallbackStr === void 0 ? 'bestFit' : _options2$fallbackStr, _options2$fallbackAxi = _options2.fallbackAxisSideDirection, fallbackAxisSideDirection = _options2$fallbackAxi === void 0 ? 'none' : _options2$fallbackAxi, _options2$flipAlignme = _options2.flipAlignment, flipAlignment = _options2$flipAlignme === void 0 ? true : _options2$flipAlignme, detectOverflowOptions = _objectWithoutProperties(_options2, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"]);
              side = getSide(placement);
              isBasePlacement = getSide(initialPlacement) === initialPlacement;
              _context4.next = 6;
              return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);
            case 6:
              rtl = _context4.sent;
              fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
              if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
                fallbackPlacements.push.apply(fallbackPlacements, _toConsumableArray(getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
              }
              placements = [initialPlacement].concat(_toConsumableArray(fallbackPlacements));
              _context4.next = 12;
              return detectOverflow(state, detectOverflowOptions);
            case 12:
              overflow = _context4.sent;
              overflows = [];
              overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
              if (checkMainAxis) {
                overflows.push(overflow[side]);
              }
              if (checkCrossAxis) {
                _getAlignmentSides2 = getAlignmentSides(placement, rects, rtl), main = _getAlignmentSides2.main, cross = _getAlignmentSides2.cross;
                overflows.push(overflow[main], overflow[cross]);
              }
              overflowsData = [].concat(_toConsumableArray(overflowsData), [{
                placement: placement,
                overflows: overflows
              }]);

              // One or more sides is overflowing.
              if (overflows.every(function (side) {
                return side <= 0;
              })) {
                _context4.next = 35;
                break;
              }
              nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
              nextPlacement = placements[nextIndex];
              if (!nextPlacement) {
                _context4.next = 23;
                break;
              }
              return _context4.abrupt("return", {
                data: {
                  index: nextIndex,
                  overflows: overflowsData
                },
                reset: {
                  placement: nextPlacement
                }
              });
            case 23:
              // First, find the candidates that fit on the mainAxis side of overflow,
              // then find the placement that fits the best on the main crossAxis side.
              resetPlacement = (_overflowsData$filter = overflowsData.filter(function (d) {
                return d.overflows[0] <= 0;
              }).sort(function (a, b) {
                return a.overflows[1] - b.overflows[1];
              })[0]) == null ? void 0 : _overflowsData$filter.placement; // Otherwise fallback.
              if (resetPlacement) {
                _context4.next = 33;
                break;
              }
              _context4.t0 = fallbackStrategy;
              _context4.next = _context4.t0 === 'bestFit' ? 28 : _context4.t0 === 'initialPlacement' ? 31 : 33;
              break;
            case 28:
              _placement = (_overflowsData$map$so = overflowsData.map(function (d) {
                return [d.placement, d.overflows.filter(function (overflow) {
                  return overflow > 0;
                }).reduce(function (acc, overflow) {
                  return acc + overflow;
                }, 0)];
              }).sort(function (a, b) {
                return a[1] - b[1];
              })[0]) == null ? void 0 : _overflowsData$map$so[0];
              if (_placement) {
                resetPlacement = _placement;
              }
              return _context4.abrupt("break", 33);
            case 31:
              resetPlacement = initialPlacement;
              return _context4.abrupt("break", 33);
            case 33:
              if (!(placement !== resetPlacement)) {
                _context4.next = 35;
                break;
              }
              return _context4.abrupt("return", {
                reset: {
                  placement: resetPlacement
                }
              });
            case 35:
              return _context4.abrupt("return", {});
            case 36:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function fn(_x8) {
        return _fn3.apply(this, arguments);
      }
      return fn;
    }()
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(function (side) {
    return overflow[side] >= 0;
  });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
var hide = function hide(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options: options,
    fn: function () {
      var _fn4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(state) {
        var _options3, _options3$strategy, strategy, detectOverflowOptions, rects, overflow, offsets, _overflow, _offsets;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _options3 = options, _options3$strategy = _options3.strategy, strategy = _options3$strategy === void 0 ? 'referenceHidden' : _options3$strategy, detectOverflowOptions = _objectWithoutProperties(_options3, ["strategy"]);
              rects = state.rects;
              _context5.t0 = strategy;
              _context5.next = _context5.t0 === 'referenceHidden' ? 5 : _context5.t0 === 'escaped' ? 10 : 15;
              break;
            case 5:
              _context5.next = 7;
              return detectOverflow(state, _objectSpread({}, detectOverflowOptions, {
                elementContext: 'reference'
              }));
            case 7:
              overflow = _context5.sent;
              offsets = getSideOffsets(overflow, rects.reference);
              return _context5.abrupt("return", {
                data: {
                  referenceHiddenOffsets: offsets,
                  referenceHidden: isAnySideFullyClipped(offsets)
                }
              });
            case 10:
              _context5.next = 12;
              return detectOverflow(state, _objectSpread({}, detectOverflowOptions, {
                altBoundary: true
              }));
            case 12:
              _overflow = _context5.sent;
              _offsets = getSideOffsets(_overflow, rects.floating);
              return _context5.abrupt("return", {
                data: {
                  escapedOffsets: _offsets,
                  escaped: isAnySideFullyClipped(_offsets)
                }
              });
            case 15:
              return _context5.abrupt("return", {});
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function fn(_x9) {
        return _fn4.apply(this, arguments);
      }
      return fn;
    }()
  };
};
function getBoundingRect(rects) {
  var minX = min.apply(void 0, _toConsumableArray(rects.map(function (rect) {
    return rect.left;
  })));
  var minY = min.apply(void 0, _toConsumableArray(rects.map(function (rect) {
    return rect.top;
  })));
  var maxX = max.apply(void 0, _toConsumableArray(rects.map(function (rect) {
    return rect.right;
  })));
  var maxY = max.apply(void 0, _toConsumableArray(rects.map(function (rect) {
    return rect.bottom;
  })));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  var sortedRects = rects.slice().sort(function (a, b) {
    return a.y - b.y;
  });
  var groups = [];
  var prevRect = null;
  for (var i = 0; i < sortedRects.length; i++) {
    var rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(function (rect) {
    return rectToClientRect(getBoundingRect(rect));
  });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
var inline = function inline(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options: options,
    fn: function () {
      var _fn5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(state) {
        var placement, elements, rects, platform, strategy, _options4, _options4$padding, padding, x, y, nativeClientRects, clientRects, fallback, paddingObject, getBoundingClientRect, resetRects;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              getBoundingClientRect = function _getBoundingClientRec() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
                  // Find the first rect in which the point is fully inside.
                  return clientRects.find(function (rect) {
                    return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                  }) || fallback;
                }

                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                  if (getMainAxisFromPlacement(placement) === 'x') {
                    var firstRect = clientRects[0];
                    var lastRect = clientRects[clientRects.length - 1];
                    var isTop = getSide(placement) === 'top';
                    var _top = firstRect.top;
                    var _bottom = lastRect.bottom;
                    var _left = isTop ? firstRect.left : lastRect.left;
                    var _right = isTop ? firstRect.right : lastRect.right;
                    var _width = _right - _left;
                    var _height = _bottom - _top;
                    return {
                      top: _top,
                      bottom: _bottom,
                      left: _left,
                      right: _right,
                      width: _width,
                      height: _height,
                      x: _left,
                      y: _top
                    };
                  }
                  var isLeftSide = getSide(placement) === 'left';
                  var maxRight = max.apply(void 0, _toConsumableArray(clientRects.map(function (rect) {
                    return rect.right;
                  })));
                  var minLeft = min.apply(void 0, _toConsumableArray(clientRects.map(function (rect) {
                    return rect.left;
                  })));
                  var measureRects = clientRects.filter(function (rect) {
                    return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                  });
                  var top = measureRects[0].top;
                  var bottom = measureRects[measureRects.length - 1].bottom;
                  var left = minLeft;
                  var right = maxRight;
                  var width = right - left;
                  var height = bottom - top;
                  return {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right,
                    width: width,
                    height: height,
                    x: left,
                    y: top
                  };
                }
                return fallback;
              };
              placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy; // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
              // ClientRect's bounds, despite the event listener being triggered. A
              // padding of 2 seems to handle this issue.
              _options4 = options, _options4$padding = _options4.padding, padding = _options4$padding === void 0 ? 2 : _options4$padding, x = _options4.x, y = _options4.y;
              _context6.t0 = Array;
              _context6.next = 6;
              return platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference);
            case 6:
              _context6.t1 = _context6.sent;
              if (_context6.t1) {
                _context6.next = 9;
                break;
              }
              _context6.t1 = [];
            case 9:
              _context6.t2 = _context6.t1;
              nativeClientRects = _context6.t0.from.call(_context6.t0, _context6.t2);
              clientRects = getRectsByLine(nativeClientRects);
              fallback = rectToClientRect(getBoundingRect(nativeClientRects));
              paddingObject = getSideObjectFromPadding(padding);
              _context6.next = 16;
              return platform.getElementRects({
                reference: {
                  getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
              });
            case 16:
              resetRects = _context6.sent;
              if (!(rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height)) {
                _context6.next = 19;
                break;
              }
              return _context6.abrupt("return", {
                reset: {
                  rects: resetRects
                }
              });
            case 19:
              return _context6.abrupt("return", {});
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function fn(_x10) {
        return _fn5.apply(this, arguments);
      }
      return fn;
    }()
  };
};
function convertValueToCoords(_x11, _x12) {
  return _convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
function _convertValueToCoords() {
  _convertValueToCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(state, value) {
    var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref6, mainAxis, crossAxis, alignmentAxis;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          placement = state.placement, platform = state.platform, elements = state.elements;
          _context11.next = 3;
          return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);
        case 3:
          rtl = _context11.sent;
          side = getSide(placement);
          alignment = getAlignment(placement);
          isVertical = getMainAxisFromPlacement(placement) === 'x';
          mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
          crossAxisMulti = rtl && isVertical ? -1 : 1;
          rawValue = typeof value === 'function' ? value(state) : value; // eslint-disable-next-line prefer-const
          _ref6 = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
          } : _objectSpread({
            mainAxis: 0,
            crossAxis: 0,
            alignmentAxis: null
          }, rawValue), mainAxis = _ref6.mainAxis, crossAxis = _ref6.crossAxis, alignmentAxis = _ref6.alignmentAxis;
          if (alignment && typeof alignmentAxis === 'number') {
            crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
          }
          return _context11.abrupt("return", isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
          } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
          });
        case 13:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _convertValueToCoords.apply(this, arguments);
}
var offset = function offset(value) {
  if (value === void 0) {
    value = 0;
  }
  return {
    name: 'offset',
    options: value,
    fn: function () {
      var _fn6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(state) {
        var x, y, diffCoords;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              x = state.x, y = state.y;
              _context7.next = 3;
              return convertValueToCoords(state, value);
            case 3:
              diffCoords = _context7.sent;
              return _context7.abrupt("return", {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function fn(_x13) {
        return _fn6.apply(this, arguments);
      }
      return fn;
    }()
  };
};
function getCrossAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
var shift = function shift(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options: options,
    fn: function () {
      var _fn7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(state) {
        var _objectSpread3;
        var x, y, placement, _options5, _options5$mainAxis, checkMainAxis, _options5$crossAxis, checkCrossAxis, _options5$limiter, limiter, detectOverflowOptions, coords, overflow, mainAxis, crossAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, _min, _max, _minSide, _maxSide, _min2, _max2, limitedCoords;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              x = state.x, y = state.y, placement = state.placement;
              _options5 = options, _options5$mainAxis = _options5.mainAxis, checkMainAxis = _options5$mainAxis === void 0 ? true : _options5$mainAxis, _options5$crossAxis = _options5.crossAxis, checkCrossAxis = _options5$crossAxis === void 0 ? false : _options5$crossAxis, _options5$limiter = _options5.limiter, limiter = _options5$limiter === void 0 ? {
                fn: function fn(_ref) {
                  var x = _ref.x,
                    y = _ref.y;
                  return {
                    x: x,
                    y: y
                  };
                }
              } : _options5$limiter, detectOverflowOptions = _objectWithoutProperties(_options5, ["mainAxis", "crossAxis", "limiter"]);
              coords = {
                x: x,
                y: y
              };
              _context8.next = 5;
              return detectOverflow(state, detectOverflowOptions);
            case 5:
              overflow = _context8.sent;
              mainAxis = getMainAxisFromPlacement(getSide(placement));
              crossAxis = getCrossAxis(mainAxis);
              mainAxisCoord = coords[mainAxis];
              crossAxisCoord = coords[crossAxis];
              if (checkMainAxis) {
                minSide = mainAxis === 'y' ? 'top' : 'left';
                maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                _min = mainAxisCoord + overflow[minSide];
                _max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = within(_min, mainAxisCoord, _max);
              }
              if (checkCrossAxis) {
                _minSide = crossAxis === 'y' ? 'top' : 'left';
                _maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                _min2 = crossAxisCoord + overflow[_minSide];
                _max2 = crossAxisCoord - overflow[_maxSide];
                crossAxisCoord = within(_min2, crossAxisCoord, _max2);
              }
              limitedCoords = limiter.fn(_objectSpread({}, state, (_objectSpread3 = {}, _defineProperty(_objectSpread3, mainAxis, mainAxisCoord), _defineProperty(_objectSpread3, crossAxis, crossAxisCoord), _objectSpread3)));
              return _context8.abrupt("return", _objectSpread({}, limitedCoords, {
                data: {
                  x: limitedCoords.x - x,
                  y: limitedCoords.y - y
                }
              }));
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function fn(_x14) {
        return _fn7.apply(this, arguments);
      }
      return fn;
    }()
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
var limitShift = function limitShift(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options: options,
    fn: function fn(state) {
      var _ref5;
      var x = state.x,
        y = state.y,
        placement = state.placement,
        rects = state.rects,
        middlewareData = state.middlewareData;
      var _options6 = options,
        _options6$offset = _options6.offset,
        offset = _options6$offset === void 0 ? 0 : _options6$offset,
        _options6$mainAxis = _options6.mainAxis,
        checkMainAxis = _options6$mainAxis === void 0 ? true : _options6$mainAxis,
        _options6$crossAxis = _options6.crossAxis,
        checkCrossAxis = _options6$crossAxis === void 0 ? true : _options6$crossAxis;
      var coords = {
        x: x,
        y: y
      };
      var mainAxis = getMainAxisFromPlacement(placement);
      var crossAxis = getCrossAxis(mainAxis);
      var mainAxisCoord = coords[mainAxis];
      var crossAxisCoord = coords[crossAxis];
      var rawOffset = typeof offset === 'function' ? offset(state) : offset;
      var computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : _objectSpread({
        mainAxis: 0,
        crossAxis: 0
      }, rawOffset);
      if (checkMainAxis) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        var _len = mainAxis === 'y' ? 'width' : 'height';
        var isOriginSide = ['top', 'left'].includes(getSide(placement));
        var _limitMin = rects.reference[crossAxis] - rects.floating[_len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        var _limitMax = rects.reference[crossAxis] + rects.reference[_len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < _limitMin) {
          crossAxisCoord = _limitMin;
        } else if (crossAxisCoord > _limitMax) {
          crossAxisCoord = _limitMax;
        }
      }
      return _ref5 = {}, _defineProperty(_ref5, mainAxis, mainAxisCoord), _defineProperty(_ref5, crossAxis, crossAxisCoord), _ref5;
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
var size = function size(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options: options,
    fn: function () {
      var _fn8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(state) {
        var placement, rects, platform, elements, _options7, _options7$apply, apply, detectOverflowOptions, overflow, side, alignment, axis, isXAxis, _rects$floating, width, height, heightSide, widthSide, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, maximumClippingWidth, maximumClippingHeight, xMin, xMax, yMin, yMax, nextDimensions;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
              _options7 = options, _options7$apply = _options7.apply, apply = _options7$apply === void 0 ? function () {} : _options7$apply, detectOverflowOptions = _objectWithoutProperties(_options7, ["apply"]);
              _context9.next = 4;
              return detectOverflow(state, detectOverflowOptions);
            case 4:
              overflow = _context9.sent;
              side = getSide(placement);
              alignment = getAlignment(placement);
              axis = getMainAxisFromPlacement(placement);
              isXAxis = axis === 'x';
              _rects$floating = rects.floating, width = _rects$floating.width, height = _rects$floating.height;
              if (!(side === 'top' || side === 'bottom')) {
                _context9.next = 29;
                break;
              }
              heightSide = side;
              _context9.t0 = alignment;
              _context9.next = 15;
              return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);
            case 15:
              if (!_context9.sent) {
                _context9.next = 19;
                break;
              }
              _context9.t1 = 'start';
              _context9.next = 20;
              break;
            case 19:
              _context9.t1 = 'end';
            case 20:
              _context9.t2 = _context9.t1;
              if (!(_context9.t0 === _context9.t2)) {
                _context9.next = 25;
                break;
              }
              _context9.t3 = 'left';
              _context9.next = 26;
              break;
            case 25:
              _context9.t3 = 'right';
            case 26:
              widthSide = _context9.t3;
              _context9.next = 31;
              break;
            case 29:
              widthSide = side;
              heightSide = alignment === 'end' ? 'top' : 'bottom';
            case 31:
              overflowAvailableHeight = height - overflow[heightSide];
              overflowAvailableWidth = width - overflow[widthSide];
              noShift = !state.middlewareData.shift;
              availableHeight = overflowAvailableHeight;
              availableWidth = overflowAvailableWidth;
              if (isXAxis) {
                maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
              } else {
                maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
              }
              if (noShift && !alignment) {
                xMin = max(overflow.left, 0);
                xMax = max(overflow.right, 0);
                yMin = max(overflow.top, 0);
                yMax = max(overflow.bottom, 0);
                if (isXAxis) {
                  availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
                } else {
                  availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
                }
              }
              _context9.next = 40;
              return apply(_objectSpread({}, state, {
                availableWidth: availableWidth,
                availableHeight: availableHeight
              }));
            case 40:
              _context9.next = 42;
              return platform.getDimensions(elements.floating);
            case 42:
              nextDimensions = _context9.sent;
              if (!(width !== nextDimensions.width || height !== nextDimensions.height)) {
                _context9.next = 45;
                break;
              }
              return _context9.abrupt("return", {
                reset: {
                  rects: true
                }
              });
            case 45:
              return _context9.abrupt("return", {});
            case 46:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function fn(_x15) {
        return _fn8.apply(this, arguments);
      }
      return fn;
    }()
  };
};
export { arrow, autoPlacement, computePosition, detectOverflow, flip, hide, inline, limitShift, offset, rectToClientRect, shift, size };